export const SUBMIT_RECOGNITION = 'setState_SUBMIT_RECOGNITION';
export const CLEAR_RECOGNITION = 'setState_CLEAR_RECOGNITION';